// extracted by mini-css-extract-plugin
module.exports = {"th":"TableHeader_th_13e1p","checkboxColumn":"TableHeader_checkboxColumn_3mpaH"};